import { generateId } from '@freelancer/datastore/testing/helpers';
import { isDefined } from '@freelancer/utils';
import type {
  BidVectorSearchAnnotation,
  BidVectorSearchAnnotationSegment,
} from './bid-vector-search-annotations.model';

export interface GenerateBidVectorSearchAnnotationOptions {
  /** Bid ID */
  readonly id?: number;
  readonly text?: string;
  readonly segments?: readonly BidVectorSearchAnnotationSegment[];
}

export interface GenerateBidVectorSearchAnnotationsOptions {
  /** Bid ID */
  readonly ids: readonly number[];
  readonly annotations: readonly Exclude<
    GenerateBidVectorSearchAnnotationOptions,
    'id'
  >[];
}

export function generateBidVectorSearchAnnotationObject({
  id = generateId(),
  text = 'Has a strong portfolio and excellent reviews.',
  segments = [
    {
      text: 'strong portfolio',
      context: {
        id: 1,
        type: 'showcase',
      },
    },
  ],
}: GenerateBidVectorSearchAnnotationOptions): BidVectorSearchAnnotation {
  return {
    id,
    text,
    segments,
  };
}

export function generateBidVectorSearchAnnotationObjects({
  ids,
  annotations,
}: GenerateBidVectorSearchAnnotationsOptions): readonly BidVectorSearchAnnotation[] {
  return ids
    .map((id, index) => {
      const annotation = annotations.at(index);

      if (annotation === undefined) {
        return undefined;
      }

      return generateBidVectorSearchAnnotationObject({
        id,
        ...annotation,
      });
    })
    .filter(isDefined);
}
